import React, { useState } from 'react';
import classNames from 'classnames';

import { TYPES, EVENTS } from 'constants/config';
import LinkButton from 'components/shared/LinkButton';
import CollapsedContentHeader from '../CollapsedContentHeader';

const MAX_NESTED_PATH_DEPTH = 2;

export default function CompletedPath(props) {
  const [showNestedLessons, setShowNestedLessons] = useState(false);
  const [hasNestedLessons, setHasNestedLessons] = useState(false);
  const depth = props.depth || 0;

  const handleShowLessons = () => {
    global.pubsub.publish(EVENTS.SET_STEP_CONNECTOR_POSITION);
    setShowNestedLessons(true);
  };

  const handleHideLessons = () => {
    global.pubsub.publish(EVENTS.SET_STEP_CONNECTOR_POSITION);
    setShowNestedLessons(false);
  };

  if (props.type !== TYPES.PATH) {
    return (
      <div className="PathContentCollapsed-nested-content">
        <CollapsedContentHeader {...props} />
      </div>
    );
  }
  if (props.depth >= MAX_NESTED_PATH_DEPTH && !showNestedLessons) {
    if (!hasNestedLessons) {
      setHasNestedLessons(true);
    }
    return (
      <div className="PathContentCollapsed-nested-content">
        <CollapsedContentHeader {...props} />
        <LinkButton className="c-brand-blue" onClick={handleShowLessons}>
          {t('paths.show_lessons')}
        </LinkButton>
      </div>
    );
  }
  return (
    <div
      className={classNames([
        'PathContentCollapsed',
        { 'PathContentCollapsed-nested-path': props.nested },
      ])}
    >
      <CollapsedContentHeader {...props} />
      {!props.nested && <div className="PathContentCollapsed-step" />}
      <div className="PathContentCollapsed-path">
        {props.contents.map(content => (
          <CompletedPath
            key={content.id}
            {...content}
            nested
            depth={depth + 1}
          />
        ))}
      </div>
      {hasNestedLessons && showNestedLessons && (
        <LinkButton className="c-brand-blue mt-8" onClick={handleHideLessons}>
          {t('paths.hide_lessons')}
        </LinkButton>
      )}
    </div>
  );
}
